import $ from 'jquery';

var el = $( '.header' );
var height = el.outerHeight();

$( '.js-scroll-to' ).on('click', function( event ) {
	if (
		location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) &&
		location.hostname === this.hostname
	) {
		var target = $( this.hash );
		target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );
		if ( target.length ) {
			event.preventDefault();
			$( 'html, body' ).animate( {
				scrollTop: target.offset().top - height
			}, 1000 );
		}
	}
} );
